import React from "react";
import { Row, Col } from "antd";
import { gapQuestions } from "./gapQuestions";
import { categories } from "../Evaluation/questions";
import sumBy from "lodash.sumby";
import compact from "lodash.compact";
import meanBy from "lodash.meanby";
import { generalIntl } from "./generalIntl";

function renderThis(category, groupedByCategory) {

  const result = groupedByCategory[category]
    .map(question => {
      const own = sumBy(groupedByCategory[category], "value");
      const peer1 = sumBy(groupedByCategory[category], "peer1");
      const peer2 = sumBy(groupedByCategory[category], "peer2");
      const peer3 = sumBy(groupedByCategory[category], "peer3");
      const ownCount = own
        ? own / groupedByCategory[category].length
        : undefined;
      const peer1Count = peer1
        ? peer1 / groupedByCategory[category].length
        : undefined;
      const peer2Count = peer2
        ? peer2 / groupedByCategory[category].length
        : undefined;
      const peer3Count = peer3
        ? peer3 / groupedByCategory[category].length
        : undefined;
      const peerAverage = meanBy(compact([peer1Count, peer2Count, peer3Count]));
      return {
        title: question.title,
        category,
        difference: Math.abs(peerAverage - ownCount)
      };
    })
    .sort((a, b) => b - a)[0];
  return result;
}

const intl = {
  category: {
    en: "category",
    dk: "kategori"
  },
  example: {
    en: "Example question",
    dk: "Spørgsmål eksempel"
  },
  headline: {
    en: "Biggest gaps",
    dk: "Eksempler på største gaps"
  }
};

function GapAnalysis(props) {
  const cat = categories["360"];
  return (
    <Row className="survey_content_container survey_results_container">
      <Col md={{ span: 12, offset: 6 }}>
        <Row>
          <Col md={{ span: 24 }} xs={24}>
            <Row gutter={16}>
              <Col md={24} style={{ marginBottom: "20px" }}>
                <h1 style={{ marginBottom: 0 }}>
                  {generalIntl.headline[props.language]}
                </h1>
                <p style={{ fontSize: "18px" }}>
                  {generalIntl.subheadline[props.language]}
                </p>
              </Col>
              <Col
                md={24}
                style={{ marginBottom: "20px", textAlign: "center" }}
              >
                <p style={{ textAlign: "left", marginBottom: "30px" }}>
                  {generalIntl.introductionText[props.language]}
                </p>
              </Col>
            </Row>
          </Col>
          <Col md={{ span: 24 }} xs={24}>
            <h1 className="gap_page_headline">
              {intl.headline[props.language]}
            </h1>
            <div
              style={{
                width: "100%",
                marginTop: "-20px",
                marginBottom: "50px",
                borderTop: "1px solid rgba(255, 255, 255, 0.3)"
              }}
            />
          </Col>
          {props.result.map((item, index) => {
            const calc = renderThis(item.category, props.groupedByCategory);
            return (
              <Col md={24} xs={24}>
                <Row className="gap_box" style={{ marginBottom: "20px", color: props.textColor ? props.textColor : 'white' }}>
                  <Col md={12} xs={24}>
                    <div style={{ fontSize: "12px", color: "#c0c0c0" }}>
                      {intl.category[props.language]}
                    </div>
                    <h2 className="gap_box_headline">
                      {cat[item.category][props.language]}
                    </h2>
                    <div style={{ paddingRight: "50px" }}>
                      {item.peerAverage - item.own > 0
                        ? gapQuestions[item.category].others[props.language]
                        : gapQuestions[item.category].own[props.language]}
                    </div>
                  </Col>
                  <Col md={12} xs={24}>
                    <h2
                      className="gap_box_headline"
                      style={{ paddingTop: "17px" }}
                    >
                      {intl.example[props.language]}
                    </h2>
                    <div>{calc.title}</div>
                  </Col>
                </Row>
              </Col>
            );
          })}
        </Row>
      </Col>
    </Row>
  );
}

export default GapAnalysis;



// WEBPACK FOOTER //
// ./src/pages/SurveyResults/GapAnalysis.js